'use client';

import { ReactNode } from 'react';
import StyledPageLayout from './PageLayout.styles';

export interface PageLayoutProps {
  children: ReactNode;
  className?: string;
  noMobilePadding?: boolean;
  noLargeDesktop?: boolean;
}

const PageLayout = ({ children, className, noMobilePadding = false, noLargeDesktop = false }: PageLayoutProps) => (
  <StyledPageLayout className={className} $noMobilePadding={noMobilePadding} $noLargeDesktop={noLargeDesktop}>
    {children}
  </StyledPageLayout>
);

export default PageLayout;
